import _DateSelect from "./DateSelect";
import { withErrorMessage } from "../withErrorMessage";

export const DateSelect = withErrorMessage(_DateSelect);

export default DateSelect;
